import { useState } from 'react'

interface IUseDimensionState {
  screenSize: { dynamicWidth: number | undefined }
  setDimensionHandler: () => void
}

/**
 * Used to manage state for the dynamic width for the <BidAcceptedModal />
 */
export const useDimension = (): IUseDimensionState => {
  const widthModal = (windowSize: number) => {
    let width

    if (windowSize > 1693) {
      width = 3
    }

    if (windowSize < 1692) {
      width = 4
    }

    if (windowSize < 1400) {
      width = 5
    }

    return width
  }

  const [screenSize, setDimension] = useState({
    dynamicWidth: widthModal(window.innerWidth),
  })

  const setDimensionHandler = () => {
    setDimension({
      dynamicWidth: widthModal(window.innerWidth),
    })
  }

  return { screenSize, setDimensionHandler }
}
